<template>
  <div class="huaao-standardSolution-check-picture" v-loading="loading">
    <div class="bigBox" v-for="component in components" v-show="component.urls.length" :key="component.id">
      <div class="box" v-for="(url,index) in component.urls" :key="url.id">
        <div class="img" :style="{'background-image':`url('${url.url}??x-oss-process=image/resize,m_fill,h_185,w_185')`}"></div>
        <p class="title">{{index+1}}.{{component.title}}</p>
        <p class="title">{{url.addTime}}</p>
        <div class="buttons">
          <el-button-group>
            <el-button type="primary" size="mini" icon="el-icon-search" @click="preview(url.url,component.title,index)"></el-button>
            <el-button type="primary" size="mini" icon="el-icon-download" @click="download(url.url)"></el-button>
          </el-button-group>
        </div>
      </div>
      <div class="clear"></div>
    </div>

    <el-button class="goback" @click="$emit('customDialogClose')">返回</el-button>

    <el-dialog ref="pictureDialog" :class="['check-picture-dialog', fullHeight && 'full-height', fullPage && 'picture-full-screen-dialog', rotate === 90 && 'rotate-90', rotate === 180 && 'rotate-180', rotate === 270 && 'rotate-270', rotate === 0 && 'rotate-0', isFullScreen && 'picture-full-screen']"
               :visible.sync="dialogVisible"
               append-to-body
               @closed="clearImgUrl"
               :show-close="false">
      <div class="title" slot="title">查看图片 -{{indexRow}}.{{currentImgTitle}}</div>
      <div class="operation">
        <!-- 旋转 -->
        <el-button class="operation-btn" @click="updateState('rotate')"><i class="el-icon-refresh-right"></i></el-button>
        <!-- 高度100% -->
        <el-button class="operation-btn" @click="updateState('fullHeight')"><i class="fa fa-arrows-v"></i></el-button>
        <!-- 全屏 -->
        <el-button class="operation-btn" @click="fullScreen"><i class="el-icon-rank"></i></el-button>
        <!-- 页面全屏 -->
        <el-button class="operation-btn" @click="updateState('fullPage')"><i class="fa fa-expand"></i></el-button>
        <!-- 关闭 -->
        <el-button class="operation-btn" @click="dialogVisible = false, updateState(null)"><i class="el-icon-close"></i></el-button>
      </div>
      <div class="img-container">
        <i class="el-icon-arrow-left img-left" @click="previousImg"></i>
        <i class="el-icon-arrow-right img-right" @click="nextImg"></i>
        <img :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'huaao-standardSolution-check-picture',
    props: ['data'],
    data () {
      return {
        dialogVisible: false,
        dialogImageUrl: '',
        info: [],
        components: [],
        sharedDownloadUrl: '',
        loading: true,
        rotate: 0, // 旋转
        fullHeight: false, // 高度100
        fullPage: false, // 页面全屏
        isFullScreen: false,
        currentImgTitle: '',
        indexRow: 0
      }
    },
    mounted () {
      this.init()
    },
    methods: {
      async init () {
        await this.$axios.get('/shared-api/files/ossDownloadUrl').then(res => {
          this.sharedDownloadUrl = res.data
        })
        // 查询控件
        let path = `repair/getPicInfoListForPc`
        await this.$axios.get(`/tpa-api/${path}`).then((res) => {
          res.data.data.forEach(n => this.components.push({
            id: n.id,
            title: n.picName,
            isSingle: n.isUniqueness,
            // max: n['f_16A2F684-5A50-1CA4-4EB4-087EA5CCC35B'],
            urls: []
          }))
        })
        debugger
        await this.$axios.get('/tpa-api/repair/getCheckCarPic', {params: {dataId: this.data.dataId, type: '维修'}}).then((res) => {
          this.info = res.data.data
          res.data.data.forEach(n => {
            let component = this.components.find(j => j.id === n.itemId)
            component && component.urls.push({
              id: n.id,
              url: this.sharedDownloadUrl + n.dir,
              addTime: n.addTime
            })
          })
        })
        this.loading = false
      },
      preview (url, title, index) {
        this.dialogImageUrl = url
        this.currentImgTitle = title
        this.dialogVisible = true
        this.indexRow =index + 1
      },
      download (url) {
        window.open(url)
      },
      previousImg () {
        let currentImgIndex
        currentImgIndex = this.info.findIndex(item => {
          return this.dialogImageUrl.indexOf(item.dir) !== -1
        })
        if (currentImgIndex === 0) {
          return this.$message.info('已经是第一张')
        }
        let previousImgUrl = this.info[currentImgIndex - 1].dir
        let urls = this.components.find(item => {
          return item.urls.length && item.urls.some(e => e.url.indexOf(previousImgUrl) !== -1)
        })
        this.currentImgTitle = urls.title
        this.dialogImageUrl = this.sharedDownloadUrl + previousImgUrl
        this.indexRow = urls.urls.findIndex(item => {
          return this.currentImgTitle && item.url === this.dialogImageUrl
        }) + 1
      },
      nextImg () {
        let currentImgIndex
        currentImgIndex = this.info.findIndex(item => {
          return this.dialogImageUrl.indexOf(item.dir) !== -1
        })
        if (currentImgIndex === this.info.length - 1) {
          return this.$message.info('已经是最后一张')
        }
        let nextImgUrl = this.info[currentImgIndex + 1].dir
        let urls = this.components.find(item => {
          return item.urls.length && item.urls.some(e => e.url.indexOf(nextImgUrl) !== -1)
        })
        this.currentImgTitle = urls.title
        this.dialogImageUrl = this.sharedDownloadUrl + nextImgUrl
        this.indexRow = urls.urls.findIndex(item => {
          return this.currentImgTitle && item.url === this.dialogImageUrl
        }) + 1
      },
      clearImgUrl () {
        this.dialogImageUrl = ''
      },
      fullScreen () {
        let fullscreenEnabled = document.fullscreenEnabled ||
          document.mozFullScreenEnabled ||
          document.webkitFullscreenEnabled ||
          document.msFullscreenEnabled
        if (!fullscreenEnabled) { return this.$message.error('当前浏览器不能全屏') }
        if (this.isFullScreen) {
          this.cancelFullscreen()
        } else {
          this.requestFullScreen(this.$refs.pictureDialog.$el)
        }
        this.isFullScreen = !this.isFullScreen
      },
      // 0：正常
      // 1：旋转
      // 2：高度100
      // 3：半全屏
      updateState (attr) {
        if (this.isFullScreen) {
          if (attr === 'fullHeight') return
          else if (attr === 'fullPage') return this.fullScreen()
        }
        if (attr === null) {
          this.rotate = 0
          this.fullHeight = false
          this.fullPage = false
        } else {
          if (attr !== 'rotate') {
            this[attr] = !this[attr]
          } else {
            this[attr] = this[attr] === 0 ? 90 : this[attr] === 90 ? 180 : this[attr] === 180 ? 270 : this[attr] === 270 ? 0 : 270
          }
        }
      },
      requestFullScreen (de) {
        if (de.requestFullscreen) {
          de.requestFullscreen()
        } else if (de.mozRequestFullScreen) {
          de.mozRequestFullScreen()
        } else if (de.webkitRequestFullScreen) {
          de.webkitRequestFullScreen()
        }
      },
      cancelFullscreen () {
        if (document.cancelFullScreen) {
          document.cancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    watch: {
      dialogVisible (val) {
        if (!val) {
          this.updateState(null)
        }
      }
    }
  }
</script>

<style lang="scss">
  .check-picture-dialog {
    width: 100%;
    height: 100%;
    .el-dialog__header {
      .title {
        font-size: 24px;
      }
    }
    .el-dialog {
      width: 900px;
      height: 510px;
      .el-dialog__body {
        box-sizing: border-box;
        position: relative;
        padding: 20px;
        height: calc(100% - 44px);
        width: 100%;
        .operation {
          position: absolute;
          right: 20px;
          top: -38.5px;

          .operation-btn {
            width: 40px;
            height: 34px;
            line-height: 34px;
            text-align: center;
            padding: 0;
            font-size: 16px;
            span {
              i {
                color: #333;
              }
            }
          }
        }
        .img-container {
          width: 100%;
          height: 100%;
          overflow: hidden;
          img {
            height: 100%;
            width: 100%;
          }
          .img-left{
            position: absolute;
            font-size: 90px;
            left: 10px;
            top: 50%;
            margin-top: -45px;
            z-index: 9999;
            cursor: pointer;
            opacity: 0.6;
          }
          .img-right{
            position: absolute;
            font-size: 90px;
            right: 10px;
            top: 50%;
            margin-top: -45px;
            z-index: 9999;
            cursor: pointer;
            color: #B0C4DE;
            opacity: 0.6;
          }
        }
      }
    }
  }
  .huaao-standardSolution-check-picture {
    height: calc(100% - 50px);
    background-color: #fff;
    overflow: auto;
    .clear {
      clear: both;
    }
    .bigBox {
      background: #fff;
      padding: 10px;
      margin-bottom: 20px;
      border-radius: 4px;
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
      transform: translate3d(0, -2px, 0);
    }
    .box {
      float: left;
      padding: 6px;
      border: 1px solid #ccc;
      border-radius: 4px;
      margin-right: 10px;
      .img {
        width: 185px;
        height: 185px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 4px;
      }
      .title {
        text-align: center;
        height: 30px;
        line-height: 30px;
      }
      .buttons {
        .el-button-group {
          float: right;
        }
      }
    }
    .goback {
      position: fixed;
      right: 20px;
      bottom: 20px;
    }
  }
  .picture-full-screen-dialog {
    width: 100%;
    height: 100%;
    .el-dialog {
      width: calc(100% - 216px);
      height: calc(100% - 65px);
      margin: 51px 8px 10px 208px !important;
    }

    .el-dialog__body {
      height: calc(100% - 44px);
    }
  }
  .rotate-90 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(90deg);
        }
      }
    }
  }
  .rotate-180 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(180deg);
        }
      }
    }
  }
  .rotate-270 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(270deg);
        }
      }
    }
  }
  .rotate-0 {
    .el-dialog {
      .el-dialog__body {
        img {
          transform: rotate(0deg);
        }
      }
    }
  }
  .full-height {
    width: 100%;
    height: 100%;
    .el-dialog {
      height: calc(100% - 101px);
      margin-top: 51px!important;
    }
  }
  .picture-full-screen {
    .el-dialog {
      width: 100%;
      height: 100%;
      margin: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/globalComponent/publicPreview/components/huaao-standardSolution-check-picture.vue